"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const file_upload_controller_1 = require("./file-upload.controller");
const file_upload_service_1 = require("./file-upload.service");
const file_upload_repository_1 = require("./file-upload.repository");
const typeorm_1 = require("@nestjs/typeorm");
const file_upload_entity_1 = require("../../../../service-lib/src/lib/entities/file-upload.entity");
const jwt_1 = require("@nestjs/jwt");
const company_entity_1 = require("../../../../service-lib/src/lib/entities/company.entity");
const archived_file_upload_entity_1 = require("./../../../../service-lib/src/lib/entities/archived-file-upload.entity");
let FileUploadModule = class FileUploadModule {
};
exports.FileUploadModule = FileUploadModule;
exports.FileUploadModule = FileUploadModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([file_upload_entity_1.FileUpload, company_entity_1.Company, archived_file_upload_entity_1.ArchivedFileUpload]),
            jwt_1.JwtModule,
        ],
        controllers: [file_upload_controller_1.FileUploadController],
        providers: [file_upload_service_1.FileUploadService, file_upload_repository_1.FileUploadRepository],
    })
], FileUploadModule);
